// extracted by mini-css-extract-plugin
export var disabled = "_1n-a";
export var hierarchyLinkGray = "_1n-4";
export var hierarchyLinkUnderline = "_1n-3";
export var hierarchyPrimary = "_1n-0";
export var hierarchySecondary = "_1n-1";
export var hierarchyTertiary = "_1n-2";
export var pressed = "_1n-6";
export var themeAction = "_1n-5";
export var themeDestructive = "_1n-8";
export var themeNormal = "_1n-7";
export var themeSuccess = "_1n-9";